/* eslint-disable eqeqeq */
/* eslint-disable react/require-default-props */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable consistent-return */
/* eslint-disable object-shorthand */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-template */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable one-var */
/* eslint-disable comma-dangle */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/* eslint-disable no-var */
/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormContainer from '../FormContainer/FormContainer';

const MarketoForm = ({
  server,
  munchkinId,
  assetId,
  name,
  onSubmitHandler,
}) => {
  const initializeMarketo = () =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://register.fastcompany.com/js/forms2/js/forms2.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const initMunchkin = () => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '//munchkin.marketo.net/munchkin.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  useEffect(() => {
    initializeMarketo()
      .then(() => {
        var userConfig = {
          apiKeys: {
            recaptcha: '6Ld-cloiAAAAADnaV1gWOVIezI4ZTBObJcn0ZM1R',
          },
          fields: {
            recaptchaFinger: 'reCaptchaSpamCheck',
          },
          actions: {
            formSubmit: 'form',
          },
          debug: {
            testBadFinger: false,
          },
        };

        /* --- NO NEED TO TOUCH BELOW THIS LINE --- */
        MktoForms2.whenReady(function (mktoForm) {
          var formEl = mktoForm.getFormElem()[0],
            submitButtonEl = formEl.querySelector("button[type='submit']");

          /* pending reCAPTCHA widget ready */
          submitButtonEl.disabled = true;

          /* pending reCAPTCHA verify */
          mktoForm.submittable(false);
          mktoForm.locked = false;
          mktoForm.onValidate(function (native) {
            if (!native) return;
            grecaptcha.ready(function () {
              grecaptcha
                .execute(userConfig.apiKeys.recaptcha, {
                  action: userConfig.actions.formSubmit,
                })
                .then(function (recaptchaFinger) {
                  var mktoFields = {};
                  if (mktoForm.locked == false) {
                    console.log('primary recaptcha response resolved');
                    mktoForm.locked = true;
                    if (!userConfig.debug.testBadFinger) {
                      mktoFields[userConfig.fields.recaptchaFinger] =
                        recaptchaFinger;
                    } else {
                      mktoFields[userConfig.fields.recaptchaFinger] =
                        'known bad fingerprint ' + Math.random();
                    }
                    mktoForm.addHiddenFields(mktoFields);
                    mktoForm.submittable(true);
                    mktoForm.submit();
                  } else {
                    console.log('secondary recaptcha response resolved');
                  }
                });
            });
          });
        });

        var recaptchaListeners = {
          ready: function () {
            MktoForms2.whenReady(function (mktoForm) {
              var formEl = mktoForm.getFormElem()[0],
                submitButtonEl = formEl.querySelector("button[type='submit']");
              submitButtonEl.disabled = false;
            });
          },
        };
        Object.keys(recaptchaListeners).forEach(function globalize(fnName) {
          window['grecaptchaListeners_' + fnName] = recaptchaListeners[fnName];
        });

        /* inject the reCAPTCHA library */
        var recaptchaLib = document.createElement('script');
        recaptchaLib.src =
          'https://www.google.com/recaptcha/api.js?render=' +
          userConfig.apiKeys.recaptcha +
          '&onload=grecaptchaListeners_ready';
        document.head.appendChild(recaptchaLib);

        window.MktoForms2.loadForm(
          server,
          munchkinId,
          assetId,
          function (form) {
            // Add an onSuccess handler
            form.onSuccess(function () {
              if (onSubmitHandler) {
                onSubmitHandler(true);
                // Return false to prevent the submission handler
                // from taking the lead to the follow up url
                return false;
              }
            });
          }
        );
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('Error initializing Marketo: ', err);
      });
    initMunchkin().then(() => {
      window.Munchkin.init('610-LEE-872');
    });
  }, []);

  return (
    <div className="newsletters__page__marketo__form__container">
      {/* Form placeholder replaced by Marketo script */}
      <FormContainer id={`mktoForm_${assetId}`} name={name} />
    </div>
  );
};

MarketoForm.propTypes = {
  server: PropTypes.string.isRequired,
  munchkinId: PropTypes.string.isRequired,
  assetId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onSubmitHandler: PropTypes.func,
};

MarketoForm.defaultProps = {
  server: '//register.fastcompany.com',
  munchkinId: '610-LEE-872',
  assetId: 1019,
  name: 'generic-marketo-form',
};

export default MarketoForm;
